"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Action extends Api_1.default {
    /**
     * Contructor
     * @param props
     */
    constructor(props) {
        super(props);
    }
    /**
     * Returns the action with the given id
     * @param action_id
     * @returns
     */
    get(action_id) {
        const requestObj = {
            method: 'get',
            url: `/action/${action_id}`,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Action;
